import urls from "../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../utils/service";

export async function punchIn(userId: string) {
  const body = { userId: userId };
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.PUNCHIN, callParams);
    console.log(response)

    return response;
  } catch (error) {
    console.log("hh")
    throw error;
  }
}
export async function checkPunchIn(userId: string) {
  const body = { userId: userId };
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.CHECKPUNCHIN, callParams);
    console.log(response)

    return response;
  } catch (error) {
    console.log("hh")
    
  }
}

export async function punchOut(
  userId: string,
  punchInId: string,
  punchInTime: string
) {
  const body = { userId, id: punchInId, punch_in: punchInTime };
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.PUNCHOUT, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
